import { Box, Button, Typography } from "@mui/material";
import React from "react";
import globalStyles from "../../global";
import { getResponsiveSize } from "../../utils/responsive";

const ChanceToMeet = ({ color, textColor }) => {
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  return (
    <Box sx={[styles.box1, { backgroundColor: color }]}>
      <Box sx={styles.box2}>
        <Box
          width={"100%"}
          display={"flex"}
          justifyContent={"space-between"}
          flexDirection={{ xs: "column-reverse", md: "row" }}
          alignItems={{ xs: "center", md: "flex-start" }}
        >
          <Box width={{ xs: "100%", md: "48%" }}>
            <Box sx={[styles.typography, { color: textColor }]}>
              YOUR CHANCE TO MEET ARUNABH SINHA!
            </Box>
            <Box mt={getResponsiveSize(2)}>
              <Typography
                variant="regular_text_ur"
                sx={{
                  color: globalStyles.colors.uclean_works,
                  fontSize: {
                    xs: "14px",
                    md: "18px",
                    lg: "18px",
                  },
                }}
              >
                Uclean Is Redefining The Global Laundry Experience Through
                Innovation, Efficiency, And Sustainability. Our Advanced
                Technology And Eco-Conscious Practices Deliver Unmatched Quality
                And Convenience, Ensuring Your Clothes Are Treated With The
                Utmost Care. UClean Is More Than A Service—It’s A Smarter,
                Greener Approach To Laundry, Designed For Today’s World.
              </Typography>
            </Box>
            <Button
              href="/events"
              variant="contained"
              sx={[
                styles.button1,
                {
                  width: { xs: "100%", sm: "60%" },
                  mt: { xs: getResponsiveSize(3), sm: getResponsiveSize(5) },
                },
              ]}
            >
              Book 1-1 Consultation
            </Button>
          </Box>
          <Box width={{ xs: "100%", md: "48%" }} mb={{ xs: 4, md: 0 }}>
            <img
              src={`${imageBaseUrl}aboutarunabh.png`}
              alt="Franchise"
              width="100%"
              style={{ maxWidth: "100%" }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  box1: {
    backgroundColor: globalStyles.colors.base_light,
    width: "100%",
    paddingBottom: { xs: getResponsiveSize(6), sm: getResponsiveSize(8) },
  },
  box2: {
    width: { xs: "90%", sm: "70%", md: "62%" },
    margin: "auto",
    paddingTop: { xs: getResponsiveSize(6), sm: getResponsiveSize(10) },
  },
  typography: {
    color: globalStyles.colors.army_green,
    fontSize: {
      xs: getResponsiveSize(28),
      sm: getResponsiveSize(36),
      md: getResponsiveSize(45),
    },
    fontFamily: globalStyles.fonts.primaryGlobal,
    fontWeight: 700,
    lineHeight: 1.2,
  },
  button1: {
    backgroundColor: globalStyles.colors.uclean_green,
    color: globalStyles.colors.white,
    height: { xs: getResponsiveSize(40), sm: getResponsiveSize(50) },
    fontSize: { xs: getResponsiveSize(14), sm: getResponsiveSize(16) },
    borderRadius: getResponsiveSize(1),

    "&:hover": {
      backgroundColor: globalStyles.colors.army_green,
      color: globalStyles.colors.white,
    },
    fontFamily: ' "Poppins", serif ',
    fontWeight: 600,
  },
};
export default ChanceToMeet;
